import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card'
import { Skeleton } from '@/components/ui/skeleton'
import { useFetchProfile } from '@/hooks/useFetchProfile'
import { toProfile } from '@/lib/link'
import { cn } from '@/lib/utils'
import { SecondaryPageLink } from '@/PageManager'
import { NostrUser } from '@nostr/gadgets/metadata'
import ProfileCard from './ProfileCard'

export default function Username({
  userId,
  className,
  skeletonClassName,
  withoutSkeleton = false
}: {
  userId: string
  className?: string
  skeletonClassName?: string
  withoutSkeleton?: boolean
}) {
  const { profile, isFetching } = useFetchProfile(userId)
  if (isFetching && !withoutSkeleton) {
    return (
      <div className="py-1">
        <Skeleton className={cn('w-16', skeletonClassName)} />
      </div>
    )
  }
  if (!profile) return null

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <div className={className}>
          <SecondaryPageLink
            to={toProfile(userId)}
            className="truncate hover:underline"
            onClick={(e) => e.stopPropagation()}
          >
            {profile.shortName}
          </SecondaryPageLink>
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-80">
        <ProfileCard userId={userId} />
      </HoverCardContent>
    </HoverCard>
  )
}

export function SimpleUsername({
  userId,
  profile: providedProfile,
  className,
  skeletonClassName,
  withoutSkeleton = false
}: {
  userId?: string
  profile?: NostrUser
  className?: string
  skeletonClassName?: string
  withoutSkeleton?: boolean
}) {
  const { profile: fetchedProfile, isFetching } = useFetchProfile(
    providedProfile ? undefined : userId
  )
  const profile = providedProfile || fetchedProfile
  if (isFetching && !withoutSkeleton) {
    return (
      <div className="py-1">
        <Skeleton className={cn('w-16', skeletonClassName)} />
      </div>
    )
  }
  if (!profile) return null

  const { shortName } = profile

  return <div className={className}>{shortName}</div>
}
